import type { IOrderRepository } from '@domain/data-contracts/order-repository.interface';
import type { Order } from '@domain/models/order.interface';
import type { OrderListQuery, PagedResult } from '@domain/models/paging.interface';

/**
 * Thin domain service over the order repository. Exists so pages
 * never touch `3.data` directly and so cross-cutting behaviour
 * (logging, correlation ids, optimistic cache helpers) has a
 * single entry point to grow into.
 */
export class OrdersService {
  public constructor(private readonly repo: IOrderRepository) {}

  public list(query: OrderListQuery): Promise<PagedResult<Order>> {
    return this.repo.list(query);
  }

  public getById(id: string): Promise<Order> {
    return this.repo.getById(id);
  }
}
